"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var modal_1 = require("ngx-bootstrap/modal");
var app_settings_1 = require("../../../constants/app-settings");
var AdminCustomScriptsEditModalComponent = /** @class */ (function () {
    function AdminCustomScriptsEditModalComponent(_bsModalRef) {
        this._bsModalRef = _bsModalRef;
        this.saveChanges = new core_1.EventEmitter();
        this.url = '';
        this.showUnsavedPrompt = false;
        this.legacyOrigin = '';
        this.legacyDirty = false;
    }
    AdminCustomScriptsEditModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        var baseUrl = app_settings_1.Settings.legacy.iframeUrl + '/Settings/OutreachTemplates/CustomScriptEditModal/?dealerID=' + this.dealerId;
        if (this.id && this.id > 0) {
            this.url = baseUrl + '&id=' + this.id;
        }
        else {
            var culture = this.culture || 'en-US';
            var scriptTypeId = this.scriptTypeId || 0;
            this.url = baseUrl + '&scriptTypeID=' + scriptTypeId + '&culture=' + encodeURIComponent(culture);
        }
        this.legacyOrigin = this.getOrigin(this.url);
        this.messageHandler = function (event) { return _this.onMessage(event); };
        window.addEventListener('message', this.messageHandler);
        this._bsModalRef.hide();
    };
    AdminCustomScriptsEditModalComponent.prototype.ngAfterViewInit = function () {
        this._bsModalRef.hide();
    };
    AdminCustomScriptsEditModalComponent.prototype.ngOnDestroy = function () {
        if (this.messageHandler) {
            window.removeEventListener('message', this.messageHandler);
        }
    };
    AdminCustomScriptsEditModalComponent.prototype.onFrameLoad = function () {
        this.postToLegacy({ type: 'CustomScriptStateRequest' });
    };
    AdminCustomScriptsEditModalComponent.prototype.onCancel = function () {
        if (this.isLegacyDirty()) {
            this.showUnsavedPrompt = true;
            return;
        }
        this.closeModal();
    };
    AdminCustomScriptsEditModalComponent.prototype.onUnsavedDiscard = function () {
        this.showUnsavedPrompt = false;
        this.closeModal();
    };
    AdminCustomScriptsEditModalComponent.prototype.onUnsavedCancel = function () {
        this.showUnsavedPrompt = false;
    };
    AdminCustomScriptsEditModalComponent.prototype.closeModal = function () {
        this.saveChanges.emit();
        this._bsModalRef.hide();
    };
    AdminCustomScriptsEditModalComponent.prototype.isLegacyDirty = function () {
        return this.legacyDirty;
    };
    AdminCustomScriptsEditModalComponent.prototype.overrideLegacyClose = function () {
        return;
    };
    AdminCustomScriptsEditModalComponent.prototype.getLegacyWindow = function () {
        if (!this.legacyFrame || !this.legacyFrame.nativeElement) {
            return null;
        }
        return this.legacyFrame.nativeElement.contentWindow;
    };
    AdminCustomScriptsEditModalComponent.prototype.postToLegacy = function (payload) {
        var legacyWindow = this.getLegacyWindow();
        if (!legacyWindow) {
            return false;
        }
        legacyWindow.postMessage(__assign({}, payload, { source: 'CustomScriptsEdit' }), '*');
        return true;
    };
    AdminCustomScriptsEditModalComponent.prototype.onMessage = function (event) {
        if (!event.data || event.data.source !== 'CustomScriptsEdit') {
            return;
        }
        switch (event.data.type) {
            case 'CustomScriptDirty':
                this.legacyDirty = Boolean(event.data.isDirty);
                break;
            case 'CustomScriptClose':
                this.closeModal();
                break;
            default:
                break;
        }
    };
    AdminCustomScriptsEditModalComponent.prototype.getOrigin = function (url) {
        try {
            var parsed = new URL(url);
            return parsed.origin;
        }
        catch (error) {
            return '';
        }
    };
    return AdminCustomScriptsEditModalComponent;
}());
exports.AdminCustomScriptsEditModalComponent = AdminCustomScriptsEditModalComponent;
